import {
  Component,
  EventEmitter,
  Input,
  Output,
  ElementRef,
  HostListener,
  OnDestroy,
} from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { DatePipe, SlicePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { debounceTime, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-filterable-column-header',
  templateUrl: './column-filter.component.html',
  styleUrl: './column-filter.component.scss',
  imports: [ButtonDirective, FormsModule, SlicePipe],
  providers: [DatePipe],
})
export class ColumnFilterComponent implements OnDestroy {
  @Input() columnName: string = '';
  @Input() columnKey: string = '';
  @Input() options: string[] = [];
  @Input() selectedValues: string[] = [];
  @Output() filterChanged = new EventEmitter<string[]>();

  dropdownOpen = false;
  searchTerm: string = '';
  displayLimit: number = 40;

  private searchSubject = new Subject<string>();
  private searchSubscription: Subscription;

  constructor(
    private elementRef: ElementRef,
    private datePipe: DatePipe,
  ) {
    this.searchSubscription = this.searchSubject
      .pipe(debounceTime(300))
      .subscribe((term) => {
        this.searchTerm = term;
      });
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
    this.searchTerm = '';
  }

  get filteredOptions(): string[] {
    if (!this.searchTerm) return this.options;
    const term = this.searchTerm.toLowerCase();
    return this.options.filter((opt) =>
      (opt ?? '').toString().toLowerCase().includes(term),
    );
  }

  onSelectionChange(option: string, checked: boolean) {
    if (checked) {
      this.selectedValues = [...this.selectedValues, option];
    } else {
      this.selectedValues = this.selectedValues.filter((v) => v !== option);
    }
    this.filterChanged.emit(this.selectedValues);
  }

  clearFilters() {
    this.selectedValues = [];
    this.filterChanged.emit([]);
    this.searchTerm = '';
  }

  get isFilterActive(): boolean {
    return this.selectedValues?.length > 0;
  }

  formatDate(dateStr: string | undefined): string {
    if (!dateStr) return '—';
    return this.datePipe.transform(dateStr, 'd MMM yyyy') ?? '—';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (
      this.dropdownOpen &&
      !this.elementRef.nativeElement.contains(event.target)
    ) {
      this.dropdownOpen = false;
    }
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
